export default __webpack_public_path__ + "static/media/fb.b14dc6c8.svg";